import { UI, Stack, VStack } from '@genial/components';
import { BoxBorder, Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import React from 'react';

import { CardItem, CardItemLoading } from './CardItem';

import { CardHeroDataProps } from '.';

export const ContentMobile: React.FC<CardHeroDataProps> = ({ isLoading, data }) => {
  const renderContent = () => {
    if (!data || isLoading) {
      return (
        <>
          <CardItemLoading isMobile />
          <CardItemLoading isMobile />
          <CardItemLoading isMobile />
          <CardItemLoading isMobile />
          <CardItemLoading isMobile />
          <CardItemLoading isMobile />
          <CardItemLoading isMobile />
        </>
      );
    }

    return (
      <>
        <CardItem isMobile label={'Nome'} value={data.nomeCliente} />
        <CardItem isMobile disabled label={'Conta sinacor'} value={data.contaSinacorComDigito} />
        <CardItem isMobile label={'E-mail'} value={data.email} />
        <CardItem isMobile label={'Conta BP'} value={data.contaBPComDigito} />
        <CardItem isMobile label={'Pessoa'} value={data.tipoPessoaNormalized} />
        <CardItem
          isMobile
          label={'Restrição Promocional'}
          value={
            data.promotionalRestriction.hasRestriction ? (
              <VStack space={Spacing['stack.quarck']}>
                <UI.Text>{data.promotionalRestriction.statusText}</UI.Text>
                <UI.Text fontSize={Typography['fontsize.xs']} color="neutral.medium">
                  Val.{' '}
                  {Utils.Mask.DateFormat(
                    data.promotionalRestriction.blackListExpirationDate,
                    'dd/MM/yyyy'
                  )}
                </UI.Text>
              </VStack>
            ) : (
              data.promotionalRestriction.statusText
            )
          }
        />
        <CardItem isMobile label={'Conta de custódia'} value={data.contaSuperPNPComDigito} />
      </>
    );
  };

  return (
    <UI.Shadow level={1} borderRadius={BoxBorder.heavy}>
      <Stack
        alignContent={'center'}
        flexDir={'column'}
        borderRadius={BoxBorder.heavy}
        bgColor={Color.background}
        width={'100%'}
        paddingX={Spacing['inline.xxxs']}
        paddingY={Spacing['inline.xxs']}
        justifyContent={'space-between'}>
        {renderContent()}
      </Stack>
    </UI.Shadow>
  );
};
